export default {
    ar: 'العربية',
    en: 'English',
    es: 'Español',
    de: 'Deutsch',
    fr: 'Français',
    it: 'Italiano',
    pl: 'Polski',
    pt: 'Português',
};
